export default "/images/menu-ico2.png?fc0bc29b3bbbf9498d7647212ecb40cd";